export default __webpack_public_path__ + "a09dd91f14c600c954d3bf251e3f1123.png";